var team22 = [
    [
        {
            name: "Hod",
            post: "Coordinator",
            fb: "https://www.facebook.com/profile.php?id=100005799362676",
            insta: "https://www.instagram.com/govind_gupta_46/",
            linkedin: "https://www.linkedin.com/in/govind-gupta-b96b1b197/",
            mail: "mailto:govindg@iitk.ac.in",
            image: "tarungupta.jpg"

        },
        {
            name: "Adivsor",
            post: "Coordinator",
            fb: "https://www.facebook.com/profile.php?id=100005799362676",
            insta: "https://www.instagram.com/govind_gupta_46/",
            linkedin: "https://www.linkedin.com/in/govind-gupta-b96b1b197/",
            mail: "mailto:govindg@iitk.ac.in",
            image: "amedury.jpg"
        }
    ],
    [
        {
            "id": "2",
            "name": "Faiza Khan",
            "post": "Coordinator",
            "fb": "https://www.facebook.com/profile.php?id=100037231279653",
            "insta": "https://www.instagram.com/faizak31/",
            "linkedin": "https://www.linkedin.com/in/faiza-khan-b21b71200/",
            "mail": "mailto:faizakhan20@iitk.ac.in",
            "image": " cordi2.jpg"
        },
        {
            "id": "3",
            "name": "Om Jee",
            "post": "Coordinator",
            "fb": "https://www.facebook.com/profile.php?id=100057579249812",
            "insta": "https://soce-iitk.github.io/soce/sections/team/#",
            "linkedin": "https://www.linkedin.com/in/om-jee-322b12212",
            "mail": "mailto:omjee20@iitk.ac.in",
            "image": "cordi3.jpg"
        },
        {
            "id": "4",
            "name": "Shubham Kumar",
            "post": "Coordinator",
            "fb": "https://www.facebook.com/profile.php?id=100058188695519",
            "insta": "https://www.instagram.com/shubham.kumar_007/",
            "linkedin": "https://www.linkedin.com/mwlite/in/shubham-kumar-9926b9209",
            "mail": "mailto:shubhamku20@iitk.ac.in",
            "image": "cordi4.jpeg"
        }
    ],
    [
        {
            "name": "Akarsha",
            "post": " Events",
            "fb": "https://www.facebook.com/profile.php?id=100074795215350",
            "insta": "https://instagram.com/akarsha_13?igshid=YmMyMTA2M2Y=",
            "linkedin": "https://www.linkedin.com/in/akarsha-yadav-077346226",
            "mail": "mailto:akarsha21@iitk.ac.in",
            "image": " e2.jpg"
        },
        {
            "name": "Dharmraj",
            "post": " Events",
            "fb": "https://www.facebook.com/dharm.raj.71653",
            "insta": "https://instagram.com/dharmraj_5565?igshid=YmMyMTA2M2Y=",
            "linkedin": "https://www.linkedin.com/in/dharm-raj-30760b22a",
            "mail": "mailto:dharmraj21@iitk.ac.in",
            "image": " e3.jpg"
        },

        {
            "name": "Mayank Shekhar",
            "post": " Events",
            "fb": "https://www.facebook.com/mayank.shekhar.710",
            "insta": "https://instagram.com/mayank___shekhar?igshid=YmMyMTA2M2Y=",
            "linkedin": "https://www.linkedin.com/in/mayank-shekhar-a71589232",
            "mail": "mailto:mshekhar21@iitk.ac.in",
            "image": " e5.jpg"
        },
        {
            "name": "Saurabh Meena",
            "post": " Events",
            "fb": "https://www.facebook.com/profile.php?id=100074976683799",
            "insta": "https://instagram.com/master_saurabh001?igshid=YmMyMTA2M2Y=",
            "linkedin": "https://www.linkedin.com/in/saurabh-meena-94600223b",
            "mail": "mailto:msaurabh21@iitk.ac.in",
            "image": " e6.jpg"
        },
        {
            "name": "Shambhavi Agarwal",
            "post": " Events",
            "fb": "https://www.facebook.com/profile.php?id=100075231073918",
            "insta": "https://instagram.com/i_shambhavi?igshid=YmMyMTA2M2Y=",
            "linkedin": "https://www.linkedin.com/in/shambhavi-agarwal-15b47b242",
            "mail": "mailto:shambhavi21@iitk.ac.in",
            "image": " e7.jpg"
        },
        {
            "name": "Srishti",
            "post": " Events",
            "fb": "https://www.facebook.com/srishti.s.10",
            "insta": "https://www.instagram.com/eunoia_ish/",
            "linkedin": "https://www.linkedin.com/in/srishti-s-557129236/",
            "mail": "mailto:srishti21@iitk.ac.in",
            "image": "e8.jpg"
        },
        {
            "name": "Aman Khilani",
            "post": " Content",
            "fb": "https://www.facebook.com/aman.khilani.5",
            "insta": "https://www.instagram.com/main.ak56/",
            "linkedin": "https://www.linkedin.com/in/aman-khilani",
            "mail": "mailto:amanrk21@iitk.ac.in",
            "image": "c1.jpg"
        },

        {
            "name": "Eshika yadav",
            "post": " Content",
            "fb": "https://www.facebook.com/eshika.yadav.9083",
            "insta": "http://instagram.com/eshika_532",
            "linkedin": "https://www.linkedin.com/in/eshika-yadav-a7a9aa23a",
            "mail": "mailto:eshikay21@iitk.ac.in",
            "image": " c3.jpg"
        },
        {
            "name": "Muskan Gautam",
            "post": " Content",
            "fb": "",
            "insta": "https://www.instagram.com/muskangautam_2203/",
            "linkedin": "",
            "mail": "mailto:muskang21@iitk.ac.in",
            "image": " c4.jpg"
        },

        {
            "name": "Sandipan Dutta",
            "post": " Content",
            "fb": "https://www.facebook.com/profile.php?id=100070465247144",
            "insta": "https://www.instagram.com/imsandipandutta03/",
            "linkedin": "https://www.linkedin.com/in/sandipan-dutta-6a03b6237/",
            "mail": "mailto:sadipand21@iitk.ac.in",
            "image": " c6.jpg"
        },
        {
            "name": "Shruti Goyal",
            "post": " Content",
            "fb": "https://www.facebook.com/profile.php?id=100073368438974",
            "insta": "https://instagram.com/shrutii_goyal_?igshid=YmMyMTA2M2Y=",
            "linkedin": "www.linkedin.com/in/shruti-goyal-581064224",
            "mail": "mailto:shrutig21@iitk.ac.in",
            "image": " c7.jpg"
        },

        {
            "name": "Harsh Vardhan ",
            "post": " Design",
            "fb": "https://www.facebook.com/profile.php?id=100074225526914",
            "insta": "https://www.instagram.com/__harshv.__10/?hl=en",
            "linkedin": "https://www.linkedin.com/in/harsh-vardhan-a1601922a",
            "mail": "mailto:harshv21@iitk.ac.in",
            "image": " d3.jpg"
        },
        {
            "name": "Kurva Shalini",
            "post": " Design",
            "fb": "https://www.facebook.com/profile.php?id=100075245501340",
            "insta": "https://instagram.com/shaliniii_2206?igshid=YmMyMTA2M2Y=",
            "linkedin": "https://www.linkedin.com/in/shalini-kurva-a05640232",
            "mail": "mailto:shalini21@iitk.ac.in",
            "image": "d4.jpg"
        },
        {
            "name": "Prateek Mishra",
            "post": " Design",
            "fb": " ",
            "insta": "",
            "linkedin": "",
            "mail": "mailto:mprateek21@iitk.ac.in",
            "image": " d5.jpg"
        },
        {
            "name": "Sanchit Hari",
            "post": " Design",
            "fb": "https://www.facebook.com/fabSANCHIT",
            "insta": "",
            "linkedin": "https://www.linkedin.com/in/sanchithari",
            "mail": "mailto:sanchit21@iitk.ac.in",
            "image": " d6.jpg"
        },
        {
            "name": "Sanju Kakerwar",
            "post": " Design",
            "fb": " ",
            "insta": "www.instagram.com/_.sanjukakerwar._/",
            "linkedin": "",
            "mail": "mailto:sanjuk21@iitk.ac.in",
            "image": " d7.jpg"
        },

       
        {
            "name": "Aashruti Raj",
            "post": " Web Development",
            "fb": "https://www.facebook.com/profile.php?id=100075348576412",
            "insta": "https://www.instagram.com/invites/contact/?i=1pvjy1qrcpo18&utm_content=kevllzc",
            "linkedin": "",
            "mail": "mailto:aashruti21@iitk.ac.in ",
            "image": " w1.jpg"
        },

        {
            "name": "Arpit Kaithwar",
            "post": " Web Development",
            "fb": "https://www.facebook.com/profile.php?id=100075288250644",
            "insta": "https://www.instagram.com/arpit_kaithwar_/",
            "linkedin": "http://www.linkedin.com/in/arpit-kaithwar-ak83035",
            "mail": "mailto:akaithwar21@iitk.ac.in",
            "image": " w3.jpg"
        },

        {
            "name": "Saurav Kumar",
            "post": " Web Development",
            "fb": "https://www.facebook.com/profile.php?id=100035038578902",
            "insta": "https://www.instagram.com/kr_saurav35/",
            "linkedin": "https://www.linkedin.com/in/saurav-kumar-1894a5226",
            "mail": "mailto:sauravkr21@iitk.ac.in",
            "image": " w5.jpg"
        },
        {
            "name": "Rishi Ratn",
            "post": " Web Development",
            "fb": "https://www.facebook.com/profile.php?id=100075245231208",
            "insta": "https://www.instagram.com/rishi_ratn/",
            "linkedin": "https://www.linkedin.com/in/rishi-ratn-53b4b4232/",
            "mail": "mailto:rishiratn21@iitk.ac.in",
            "image": "rishi.jpg"
        },
        {
            "name": "Abhimanyu Jain",
            "post": " Web Development",
            "fb": "https://www.facebook.com/abhimanyu.jain.56679",
            "insta": "https://www.instagram.com/_abhimanyu_jain_/",
            "linkedin": "https://www.linkedin.com/in/abhimanyu-jain-a465b8232/",
            "mail": "mailto:abhimanyuj21@iitk.ac.in",
            "image": "abhi.jpg"
        },

        {
            "name": "Aadya Umrao",
            "post": " Marketing & Finance",
            "fb": "https://www.facebook.com/profile.php?id=100082214229058",
            "insta": "https://www.instagram.com/invites/contact/?i=1cxfnglh9qn6e&utm_content=kejcmen",
            "linkedin": "https://www.linkedin.com/in/aadya-umrao-b63b9922b",
            "mail": "mailto:aadyau21@iitk.ac.in",
            "image": " m1.jpg"
        },


        {
            "name": "Enna Gupta",
            "post": " Marketing & Finance",
            "fb": "https://www.facebook.com/enna.gupta.104",
            "insta": "https://instagram.com/enna_1902",
            "linkedin": "https://www.linkedin.com/in/enna-gupta-013340240",
            "mail": "mailto:ennagupta21@iitk.ac.in ",
            "image": "m4.jpg"
        },
        {
            "name": "Ishu Singh",
            "post": " Marketing & Finance",
            "fb": "https://www.facebook.com/profile.php?id=100008697333618",
            "insta": "http://instgram.com/ishu_iitk",
            "linkedin": "https://www.linkedIn.com/in/ishu-singh-58a484242",
            "mail": "mailto:ishusingh21@iitk.ac.in ",
            "image": " m5.jpg"
        },
        {
            "name": "Pratham Srivastava",
            "post": " Marketing & Finance",
            "fb": "https://www.facebook.com/profile.php?id=100074946619797",
            "insta": "https://instagram.com/1prthm_srvstv?igshid=YmMyMTA2M2Y=",
            "linkedin": "https://www.linkedin.com/in/pratham-srivastava-a70085230",
            "mail": "mailto:prathams21@iitk.ac.in",
            "image": "m6.jpg"
        },
        {
            "name": "Shrey Patel",
            "post": " Marketing & Finance",
            "fb": "https://www.facebook.com/shrey.patel.5243",
            "insta": "https://www.instagram.com/shreypatel1408/",
            "linkedin": "https://www.linkedin.com/in/shrey-patel-830bb164/",
            "mail": "mailto:shreypatel21@iitk.ac.in",
            "image": " m7.jpg"
        },
        {
            "name": "Vanshika Yadav",
            "post": " Marketing & Finance",
            "fb": "https://www.facebook.com/profile.php?id=100075371045211",
            "insta": "https://www.instagram.com/vanshu_ydav/",
            "linkedin": "https://www.linkedin.com/in/vanshika-yadav-468a58233",
            "mail": "mailto:vanshika21@iitk.ac.in",
            "image": "m8.jpg"
        },
        {
            "name": "Yagyavalkya Soan",
            "post": " Marketing & Finance",
            "fb": "https://www.facebook.com/yash.soan.395",
            "insta": "https://www.instagram.com/yash_soan/",
            "linkedin": "https://www.linkedin.com/in/ysoan21/",
            "mail": "mailto:ysoan21@iitk.ac.in",
            "image": " yag.jpg"
        },
       
    ],
]

module.exports = team22;